import React from "react";
import { Link } from "react-router-dom";

const RedButton = ({
  btntext,
  name,
  type = "button",
  onClick,
  to,
  className = "",
  state,
}) => {
  const handleClick = (e) => {
    if (onClick) {
      e.preventDefault();
      onClick(e);
    }
  };

  if (to) {
    return (
      <Link
        to={to}
        state={state}
        name={name}
        onClick={handleClick}
        className={`w-33 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 ${className}`}
      >
        {btntext}
      </Link>
    );
  }

  return (
    <button
      type={type}
      name={name}
      onClick={handleClick}
      className={`w-33 fw-bold ft-14 text-white px-5 py-3 bgred rounded-2 cursor-target text-center hover:tw-bg-[#333] tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-scale-105 ${className}`}
    >
      {btntext}
    </button>
  );
};

export default RedButton;
